export enum SampleEventsEnum {
  RemoveCartEntry = 'RemoveCartEntry',
  UpdateCartEntryQty = 'UpdateCartEntryQty',
  AddToCart = 'AddToCart',
}

export enum Language {
  EN = 'en',
  TH = 'th',
  ES = 'es',
}

export enum Country {
  TH = 'th',
  CO = 'co',
}

export enum Locale {
  EN_US = 'en-us',
  TH_TH = 'th-th',
  ES_CO = 'es-co',
}
